import { render } from "./DispatchContainerInfo.vue?vue&type=template&id=3cf66ec4&ts=true"
import script from "./DispatchContainerInfo.vue?vue&type=script&lang=ts"
export * from "./DispatchContainerInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__